<template>
<div>
  <v-card class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 tw-mt-5 md:tw-mt-10 tw-pb-5">
    <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl tw-px-0 md:tw-px-10">
      Select an option to continue
      <hr class="tw-mt-4">
    </h3>
    <div class="tw-w-full tw-flex tw-flex-col">
      <div class="tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-my-2 md:tw-my-4">
        <v-card class="tw-w-full md:tw-w-1/2 tw-flex tw-items-center tw-flex-wrap tw-justify-center tw-p-4 md:tw-p-6 tw-mt-4">
          <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10">
            <h2 class="c-blue-text tw-text-xl tw-font-bold">Renew Existing Policy</h2>
            <p class="tw-w-full c-gray-text tw-text-base">Coverage extension, benefits modifications and switch payment plan</p>
          </div>
          <div class="tw-w-full tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0">
            <v-btn color="secondary" class="tw-mt-2" large block :loading="loading" @click="proceedToRenew()">Continue</v-btn>
          </div>
        </v-card>
        <v-card class="tw-w-full md:tw-w-1/2 tw-flex tw-items-center tw-flex-wrap tw-justify-center tw-p-4 md:tw-p-6 tw-mt-4 lg:tw-mt-8">
          <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10">
            <p class="c-blue-text tw-text-xl tw-font-bold">Change Cover Type</p>
            <p class="tw-w-full c-gray-text tw-text-base">Switch to another APA Motor Insurance product to suit your needs</p>
          </div>
          <div class="tw-w-full tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0">
            <v-btn color="secondary" class="tw-mt-2" large block :loading="loading" @click="proceedToChange()">Change</v-btn>
          </div>
        </v-card>
      </div>
    </div>
  </v-card>
</div>
</template>

<script>
import { FB_RENEW_EXISTING, FB_RENEW_CHANGE } from '@/utils/const';

export default {
  name: 'SelectOption',
  data() {
    return {
      loading: false,
    };
  },
  metaInfo: {
    title: 'Start Renewal',
  },
  methods: {
    proceedToRenew() {
      this.$analytics.logEvent(FB_RENEW_EXISTING, { product: 'Renewal Journey Exiting' });
      this.$emit('to-personal-details-review', false);
    },
    proceedToChange() {
      this.$analytics.logEvent(FB_RENEW_CHANGE, { product: 'Renewal Journey Change Cover' });
      this.$emit('to-personal-details-review', true);
    },
  },
};
</script>
